module.exports = __webpack_public_path__ + "img/pol.562edca5.svg";